import React, { useState, useEffect } from 'react';
import { Typography } from "@mui/material";
import { AuthProvider, useAuth } from "./AuthContext";

const ResponsiveTypography = () => {
    const [isMobile, setIsMobile] = useState(false);
    const { companyName, companyId, isSuperAdmin, superCompanyId, roleName } = useAuth();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        handleResize(); // Check the initial screen size
        window.addEventListener('resize', handleResize); // Listen for window resize events

        return () => window.removeEventListener('resize', handleResize); // Clean up the event listener
    }, []);

    return (
        <Typography
            variant="h5"
            className="dual-text"
            component="div"
            style={{
                marginLeft: '16px',
                fontWeight: 'bolder',
                position: 'relative',
                fontSize: '24px',
            }}
        >
            {isMobile ? 'ABK' : companyName}
        </Typography>
    );
};

export default ResponsiveTypography;
